import ChevronDownIcon from '../../../icons/chevrons/down.svg'
import ChevronUpIcon from '../../../icons/chevrons/up.svg'

export const ProfileActionsWidgetExpandAllButtonAction = {
  collapse: 'collapseAllWidgets',
  expand: 'expandAllWidgets',
}

export const PROFILE_ACTIONS_WIDGET_EXPAND_ALL_BUTTON_ICON = {
  [ProfileActionsWidgetExpandAllButtonAction.collapse]: ChevronUpIcon,
  [ProfileActionsWidgetExpandAllButtonAction.expand]: ChevronDownIcon,
}

export const PROFILE_ACTIONS_WIDGET_EXPAND_ALL_BUTTON_TOOLTIP_KEY = {
  [ProfileActionsWidgetExpandAllButtonAction.collapse]:
    'Profile.ActionsWidgetCollapseAllWidgetsTooltipKey',
  [ProfileActionsWidgetExpandAllButtonAction.expand]:
    'Profile.ActionsWidgetExpandAllWidgetsTooltipKey',
}
